module.exports = __webpack_public_path__ + "static/media/GLORY_8330.12ef8e96.jpg";